export const EventListSkeleton = () => (
  <div aria-hidden="true" className="flex items-center gap-4 border-b border-border px-4 py-3">
    <div className="min-w-0 flex-1 space-y-2 motion-safe:animate-pulse">
      <div className="h-4 w-2/3 rounded bg-muted" />
      <div className="h-3 w-5/6 rounded bg-muted" />
      <div className="h-3 w-1/3 rounded bg-muted" />
    </div>
    <div className="h-6 w-16 rounded bg-muted motion-safe:animate-pulse" />
  </div>
);
